export default __webpack_public_path__ + "static/101474-a427ece999ecc6d226370708c4db1638.jpg";